<div class="risk-form">
  <form [formGroup]="form">

    <h5 class="risk-section-title">Risk</h5>
    <div class="row">
      @if (isEditPage) {
        <div class="col-lg-2 col-md-4 col-sm-6">
          <input-field
            label="Code"
            [inputFormControl]="getControl('code')"
            [type]="'text'"
            [placeholder]="' '"
            [readonly]="true">
          </input-field>
        </div>
      }

      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="form-group">
          <label class="fw-bold risk-field-label">Type</label>
          <select-field
            [selectFormControl]="getControl('type')"
            [options]="typeOptions">
          </select-field>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6">
        <input-field
          label="Date"
          [inputFormControl]="getControl('date')"
          [type]="'datetime-local'">
        </input-field>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="form-group">
          <label class="fw-bold risk-field-label">Status</label>
          <select-field
            [selectFormControl]="getControl('status')"
            [options]="statusOptions">
          </select-field>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6">
        <div class="form-group">
          <label class="fw-bold risk-field-label">Priority</label>
          <select-field
            [selectFormControl]="getControl('priority')"
            [options]="priorityOptions">
          </select-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6">
        <input-field
          label="Next Review"
          [inputFormControl]="getControl('nextReview')"
          [type]="'datetime-local'">
        </input-field>
      </div>

      @if (isEditPage) {
        <div class="col-lg-3 col-md-4 col-sm-6">
          <input-field
            label="Creator"
            [inputFormControl]="getControl('creator')"
            [type]="'text'"
            [readonly]="true">
          </input-field>
        </div>
      }
    </div>

    <h5 class="risk-section-title">Assessment</h5>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <textarea-field
          label="Description"
          placeholder="What the risk is about"
          [textareaFormControl]="getControl('description')"
          [readonly]="!canSave"
          [height]="150">
        </textarea-field>
      </div>

      <div class="col-lg-4 col-md-6">
        <textarea-field
          label="Opportunity"
          placeholder="What could be gained"
          [textareaFormControl]="getControl('opportunity')"
          [readonly]="!canSave"
          [height]="150">
        </textarea-field>
      </div>

      <div class="col-lg-4 col-md-6">
        <textarea-field
          label="Threat"
          placeholder="What could go wrong"
          [textareaFormControl]="getControl('threat')"
          [readonly]="!canSave"
          [height]="150">
        </textarea-field>
      </div>
    </div>

  </form>

  <h5 class="risk-section-title">Action Proposes</h5>
  <risk-action-proposes
    [actionProposes]="actionProposes"
    [riskId]="riskId"
    [responsibleOptions]="responsibleOptions"
    [timeFrameOptions]="timeFrameOptions"
    [readonlyRows]="!canSave"
    (addRow)="addActionPropose()"
    (removeRow)="removeActionPropose($event)"
    (attachmentUploaded)="reloadRisk()">
  </risk-action-proposes>

  @if (canSave) {
    <div class="d-flex justify-content-end align-items-end my-2">
      <button type="button" class="btn btn-success" (click)="submitForm()">Save</button>
    </div>
  }
</div>
